<!-- ------------------Page Heading Start------------- -->

<div class="page_heading">
    <div class="container">
        <h2>Gallery</h2>
    </div>
</div>

<!-- ------------------Page Heading End------------- -->
<!-- -------------------------Gallery Section Start----------------- -->


<section class="portfolio_section rs-section gl" rsParallax>
    <div class="rs-deco" aria-hidden="true">
        <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
        <span class="rs-blob rs-blob--pink rs-blob--br"></span>
        <span class="rs-dots rs-dots--a"></span>
        <span class="rs-dots rs-dots--pink rs-dots--b"></span>
        <span class="rs-ring rs-ring--b"></span>
        <span class="rs-spark" style="--sx: 12%; --sy: 34%; --sd: 0.5s"></span>
        <span class="rs-spark" style="--sx: 86%; --sy: 70%; --sd: 2.3s"></span>
    </div>

    <div class="container rs-shell">
        <header class="rs-head--center gl__head" rsReveal="up">
            <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Life at Resiliencesoft</span>
            <h2 class="rs-title rs-title--lg">Inside our <span class="rs-title-grad">studio</span></h2>
            <p class="rs-lede rs-lede--center">
                Offsites, launch days, workshops and the everyday. Tap any photo to open it
                full size.
            </p>
        </header>

        <!-- <div class="row"> -->
            <mat-tab-group class="gl__tabs">
                <mat-tab label="All">
                    <app-gallerymodel [GalleryData]=data [showCount]="true"></app-gallerymodel>
                </mat-tab>
                <mat-tab label="Office">
                    <app-gallerymodel [GalleryData]=officedata [showCount]="true"></app-gallerymodel>
                </mat-tab>
                <mat-tab label="Activity">
                    <app-gallerymodel [GalleryData]=activitydata [showCount]="true"></app-gallerymodel>
                </mat-tab>
                <mat-tab label="Employee">
                    <app-gallerymodel [GalleryData]=employeedata [showCount]="true"></app-gallerymodel>
                </mat-tab>
                <mat-tab label="Tour">
                    <app-gallerymodel [GalleryData]=tourdata [showCount]="true"></app-gallerymodel>
                </mat-tab>
                <mat-tab label="Party">
                    <app-gallerymodel [GalleryData]=partydata [showCount]="true"></app-gallerymodel>
                </mat-tab>
            </mat-tab-group>
        <!-- </div> -->
    </div>
</section>


<!-- -------------------------Portfolio Section End----------------- -->
